import React, { useEffect, useState } from "react";
import { Smartphone, X, Share } from "lucide-react";

const KEY = "sl-install-dismissed";
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isPhone = () => window.matchMedia("(max-width: 768px)").matches;

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || !isPhone() || localStorage.getItem(KEY)) return;
    setShow(true);
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  if (!show) return null;
  return (
    <div className="mb-8 flex items-start gap-3 rounded-2xl bg-[#F2EBE5] p-4 fade-up" data-testid="install-prompt">
      <Smartphone size={20} className="text-[#2A3B32] mt-0.5 shrink-0" />
      <div className="flex-1 text-sm text-[#1C221D] leading-relaxed">
        <div className="font-semibold">Keep India one tap away</div>
        {deferred ? (
          <button onClick={install} data-testid="install-prompt-button"
            className="mt-2 px-4 py-2 rounded-full bg-[#2A3B32] text-[#FDFBF7] text-sm active:scale-95 transition-transform duration-200">
            Add to home screen
          </button>
        ) : isIOS() ? (
          <p data-testid="install-prompt-ios">
            Tap <Share size={14} className="inline -mt-0.5" /> Share, then <b>Add to Home Screen</b>.
          </p>
        ) : (
          <p data-testid="install-prompt-other">Open your browser menu and tap <b>Add to Home screen</b>.</p>
        )}
      </div>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="install-prompt-dismiss"
        className="h-9 w-9 -m-1 flex items-center justify-center rounded-full text-[#5C6A61] hover:bg-white/60">
        <X size={16} />
      </button>
    </div>
  );
};
